import React from 'react';

import { Icon } from '@hz-design-system/web-ui';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Attribute } from '@/client/types/Listings';
import { ListingAttribute } from '@/client/components/ListingsNew/components';

interface ListingAttributesProps {
  carPassUrl?: Attribute;
  napAvailable?: boolean;
}

const ListingAttributes: React.FC<ListingAttributesProps> = ({ carPassUrl, napAvailable }) => {
  return (
    <>
      {carPassUrl && (
        <ListingAttribute type="nap">
          <Icon name="checkmark-circle" color="success" />
          <Trans tagName="span" i18nKey="listings.carPass" />
        </ListingAttribute>
      )}
      {napAvailable && (
        <ListingAttribute type="nap">
          <Icon name="checkmark-circle" color="success" />
          <Trans tagName="span" i18nKey="listings.nap" />
        </ListingAttribute>
      )}
    </>
  );
};

export default ListingAttributes;
